import React from 'react';
import TableGrid from '../../../../../SharedModules/Table/TableGridWithFeatures';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../../SharedModules/AgGridUtilities/suppressNavigation';

function Grid(props) {
  const {
    rowData,
    columnDefs,
    cellClickedListener,
    gridHeight,
    fullScreenView,
    setFullScreenView,
  } = props;

  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
  };

  return (
    <div className='panel tBillPanel-space pb-0'>
      <div className='clearfix' />
      <TableGrid
        gridHeight={gridHeight}
        rowData={rowData}
        columnDefs={columnDefs}
        data-testid='onEditingStopped'
        enterMovesDown
        suppressCellFocus
        onCellFocused={onCellFocused}
        singleClickEdit={false}
        navigateToNextCell={navigateToNextCell}
        tabToNextCell={tabToNextCell}
        onSelect={cellClickedListener}
        handleFullScreenViewClick={handleFullScreenViewClick}
        exportFile
        fileName='ClientGroup'
      />
    </div>
  );
}
export default Grid;
